import { createStore } from "vuex";
import delivery from "./modules/delivery";
import sales from "./modules/sales";
import sale_products from "./modules/sale_products";
import session from "./modules/session";
import rules from "./modules/rules";
import stores from "./modules/stores";

export default createStore({
  state: {
    layout: "desktop",
    project: "FTX4"
  },
  getters: {
    getCurrentLayout(state) {
      return state.layout;
    },
    isDesktop(state) {
      return state.layout === "desktop";
    },
    isMobile(state) {
      return state.layout.includes("mobile");
    },
    isTabletPortrait(state) {
      return state.layout === "tablet_portrait";
    },
    isTabletLandscape(state) {
      return state.layout === "tablet_landscape";
    },
    isMobilePortrait(state) {
      return state.layout === "mobile_portrait";
    },
    isMobileLandscape(state) {
      return state.layout === "mobile_landscape";
    },
    getCurrentProject(state) {
      return state.project;
    },
    isFTX4(state, getters) {
      return getters.getCurrentProject === "FTX4";
    },
    sessionDataLoaded(state, getters) {
      const userData = getters.getUserData;
      const userRole = getters.getUserRole;
      const stores = getters.getAvailableStores;
      return userData && userRole && stores;
    }
  },
  mutations: {
    setCurrentLayout(state, payload) {
      state.layout = payload;
    },
    setCurrentProject(state, payload) {
      state.project = payload;
    }
  },
  actions: {
    loadLocalStorage({ commit }) {
      const data = JSON.parse(localStorage.getItem("xmartshelf_admin") || "{}");
      if (data.session) commit("setSession", data.session);
      if (data.selectedSale) commit("setSaleId", data.selectedSale);
    }
  },
  modules: {
    delivery,
    sales,
    sale_products,
    session,
    rules,
    stores
  }
});
